import { useQueryWithErrorHandling } from './useQueryWithErrorHandling'
import { getDeepRailways } from 'src/Providers/DeepRailways'
import type { DeepRailway } from 'src/Types/DeepRailway'
import { useGenericCacheBehaviour } from 'src/Hooks/useGenericCacheBehaviour'
import { LocationFeatures, useLocationFeature } from '../useLocationFeatures'

export const useDeepRailways = () => {
  const usingUnsafeSorting = useLocationFeature(LocationFeatures.UnsafeSorting)
  const { getFreshOrCachedValue } = useGenericCacheBehaviour<DeepRailway[]>({
    partialKey: 'railwaysCache',
    getFreshValue: () => getDeepRailways(usingUnsafeSorting),
  })

  return useQueryWithErrorHandling(
    ['deeprailways'],
    () => getFreshOrCachedValue(),
    {
      staleTime: Infinity,
    },
    'location.region.fetchError'
  )
}
